const submitBtns = Array.from(document.querySelectorAll('input[type="submit"].FormButton'));

if (submitBtns.length) {
	submitBtns.forEach((btn) => {
	  btn.addEventListener('click', () => {
	    document.body.scrollTop = 0; 
	    document.documentElement.scrollTop = 0; 
	  })
	})
}




// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/form-to-top.js